export const config = {
  url_api_back_end : "http://localhost:8220/api",
  url_api_vultr_service : "https://api.vultr.com/v2",
  url_api_digital_ocean_service : "https://api.digitalocean.com/v2",
  local_api_proxy_service : "http://localhost:8010/proxy",
  api_key_vultr_service : "GXORW6TAGHIINJ75JIZ6JBYLP5EB5HGEWJXQ",
  api_key_digital_ocean_service : "3e5027f8d19053e9ce260b82f3a277e07f6c0d13c58625528a00190a0e224fb7",
  typePlanQuery: "vc2",
}



// WEBPACK FOOTER //
// ./src/constants/config.js